import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Sidebar = ({ isMobileOpen, onClose }) => {
  const { isAdmin } = useAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const menuItems = isAdmin() ? [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/dashboard/users', label: 'Utilisateurs', icon: '👥' },
    { path: '/dashboard/channels', label: 'Chaînes', icon: '📺' },
    { path: '/dashboard/videos', label: 'Vidéos', icon: '🎬' },
  ] : [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/dashboard/my-channels', label: 'Mes Chaînes', icon: '📺' },
    { path: '/dashboard/my-videos', label: 'Mes Vidéos', icon: '🎬' },
  ];

  const isActive = (path) => location.pathname === path;

  const handleLinkClick = () => {
    if (isMobile && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      {isMobile && isMobileOpen && (
        <div 
          style={styles.overlay}
          onClick={onClose}
        />
      )}

      <aside style={{
        ...styles.sidebar,
        ...(isMobile ? styles.sidebarMobile : {}),
        width: isMobile ? '280px' : (isOpen ? '260px' : '80px'),
        transform: isMobile && !isMobileOpen ? 'translateX(-100%)' : 'translateX(0)',
      }}>
        {!isMobile && (
          <button
            onClick={() => setIsOpen(!isOpen)}
            style={styles.toggleBtn}
            title={isOpen ? 'Réduire' : 'Agrandir'}
          >
            {isOpen ? '←' : '→'}
          </button>
        )}

        {isMobile && (
          <div style={styles.mobileHeader}>
            <h3 style={styles.mobileTitle}>Menu</h3>
            <button
              onClick={onClose}
              style={styles.closeBtn}
              aria-label="Close menu"
            >
              ✕
            </button>
          </div>
        )}

        <nav style={styles.nav}>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={handleLinkClick}
              style={{
                ...styles.menuItem,
                ...(isActive(item.path) ? styles.menuItemActive : {}),
              }}
            >
              <span style={styles.icon}>{item.icon}</span>
              {(isOpen || isMobile) && <span>{item.label}</span>}
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
};

const styles = {
  sidebar: {
    background: 'white',
    boxShadow: '2px 0 8px rgba(0, 0, 0, 0.05)',
    height: 'calc(100vh - 80px)',
    position: 'sticky',
    top: '80px',
    transition: 'width 0.3s ease, transform 0.3s ease',
    padding: '1.5rem 0',
    overflow: 'hidden',
    zIndex: 100,
  },
  sidebarMobile: {
    position: 'fixed',
    top: '80px',
    left: 0,
    height: 'calc(100vh - 80px)',
    zIndex: 1000,
    boxShadow: '4px 0 20px rgba(0, 0, 0, 0.15)',
  },
  overlay: {
    position: 'fixed',
    top: '80px',
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 999,
    animation: 'fadeIn 0.2s ease-out',
  },
  toggleBtn: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: '1px solid var(--border)',
    background: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
  },
  mobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem 1.5rem',
    borderBottom: '1px solid var(--border)',
    marginBottom: '1rem',
  },
  mobileTitle: {
    fontSize: '1.125rem',
    fontWeight: 600,
    color: 'var(--text)',
    margin: 0,
  },
  closeBtn: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: '1px solid var(--border)',
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.25rem',
    color: 'var(--text)',
    transition: 'all 0.2s ease',
  },
  nav: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '0 1rem',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    textDecoration: 'none',
    color: 'var(--text)',
    fontSize: '0.875rem',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
  },
  menuItemActive: {
    background: 'var(--primary)',
    color: 'white',
  },
  icon: {
    fontSize: '1.25rem',
    minWidth: '24px',
    textAlign: 'center',
  },
};

export default Sidebar;





